import umiru_pdf from "../../../../contents/works/UMIRU/umiru.pdf";
import * as React from 'react';
export default {
  umiru_pdf,
  React
};